<template>
	<div class="carousel-block-item">
		<PictureImg class="carousel-block-item__image" :media="image"></PictureImg>

		<div class="carousel-block-item__title">
			{{ title }}
		</div>
		<div class="carousel-block-item__content" v-html="content"></div>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const image = computed(() => props.fields?.image?.value);
const title = computed(() => props.fields?.title?.value);
const content = computed(() => props.fields?.content?.value);
</script>

<style lang="scss">
.carousel-block-item {
	color: var(--color-white, #fff);
	padding: var(--spacing-2, 16px);
	display: block;
	width: 80%;

	.carousel-block-item__image img {
		padding: 0;
		border-radius: 16px;
		overflow: hidden;
		aspect-ratio: 1 / 1;
		object-fit: cover;
	}

	.carousel-block-item__title {
		margin: 24px 0;
		font-size: var(--text-xl, 24px);
		font-weight: 900;
		line-height: 120%;
		text-transform: uppercase;
	}

	.carousel-block-item__content {
		margin: 24px 0;
		font-size: var(--text-base, 16px);
		font-weight: 400;
		line-height: 140%;
	}
}
</style>
